import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Icon } from '../../icon/icon';
import { Link, Target } from '../../link/link';
const b = bemClassBuilder('v-display-text-link');
export const DisplayTextLink = observer(({ part, internalActions }) => {
    const { text, iconName, className, href, onClick, internalAction, openInNewTab, ariaLabel } = part;
    const handleClick = event => {
        var _a;
        if (internalAction) {
            const action = (_a = internalActions === null || internalActions === void 0 ? void 0 : internalActions.find(na => na.name === internalAction)) === null || _a === void 0 ? void 0 : _a.action;
            if (!action) {
                throw new Error(`Cannot find internalAction: ${internalAction}.`);
            }
            action();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    const hasClickHandler = !!(onClick || internalAction);
    return (_jsxs(Link, { className: b.block({ hasIcon: !!iconName }, className), onClick: hasClickHandler ? handleClick : undefined, href: href, target: openInNewTab ? Target.Blank : undefined, ariaLabel: ariaLabel, children: [_jsx("span", { children: text }), iconName && _jsx(Icon, { name: iconName, className: b.element('icon') })] }));
});
DisplayTextLink.displayName = 'DisplayTextLink';
//# sourceMappingURL=link.js.map